import {Pipe, PipeTransform} from '@angular/core';

@Pipe({standalone: true, name: 'breakLines'})
export class BreakLinesPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    if (!value) {
      return "";
    }
    return value
      .replace(/\r\n|\r|\n/g, '<br/>')
      .replace(/\t/g, '&emsp;');
  }
}
